export const pollStatus = {
  saved: "saved",
  open: "open",
  closed: "closed",
};
